export default __webpack_public_path__ + "static/media/640_business03-fr-web.42aa4534.png";